import AlertType from 'common/types/AlertType';
import React from 'react';
import Alert from './Alert';

interface IErrorAlert {
    children: React.ReactNode;
}

const ErrorAlert = (props: IErrorAlert) => {
  return <Alert type={AlertType.danger}>{ props.children }</Alert>;
};

export default ErrorAlert;
